import PendingPods from './styled';

export default PendingPods;
